module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-33-10e2334943b9b0ff83ef473aaf20ef63.svg";